import { render } from "./ValidateTabletFormComponentDetails.vue?vue&type=template&id=41bd17b8"
import script from "./ValidateTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./ValidateTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__